<template>
  <div id="app">
    <TheNavbar />
    <main id="content">
      <router-view @ready="pageReady" />
    </main>
    <TheFooter />
  </div>
</template>

<script>
import TheNavbar from '@/components/TheNavbar'
import TheFooter from '@/components/TheFooter'
import NProgress from 'nprogress'
import picturefill from 'picturefill'

export default {
  components: {
    TheNavbar,
    TheFooter
  },

  data () {
    return {
      showPage: false
    }
  },

  methods: {
    pageReady () {
      this.showPage = true
      picturefill()
      NProgress.done()
    }
  },

  created () {
    NProgress.configure({
      speed: 200,
      showSpinner: false
    })
    NProgress.start()
    this.$router.beforeEach((to, from, next) => {
      this.showPage = false
      NProgress.start()
      next()
    })
  }
}
</script>

<style lang="scss">
@import 'assets/scss/app.scss';
@import '~nprogress/nprogress.css';

body {
  padding-top: $navbar-height;

  @include media-breakpoint-up(md) {
    padding-top: $navbar-height-lg;
  }
}
.page {
  padding-bottom: 40px;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#nprogress .bar {
  background: $nprogress-color;
}
</style>
